import { debounce } from 'lodash';

// Dashboard List Widget

// Disable pagination buttons if no overflow is hidden
document.querySelectorAll('.dashboard-list-widget').forEach((widgetCardElement) => {
    const paginationElement = widgetCardElement.querySelector('.dashboard-list-widget-pagination');
    const listElement       = widgetCardElement.querySelector('.dashboard-list-widget-list');

    if (listElement && listElement.clientWidth >= listElement.scrollWidth) {
        paginationElement.querySelectorAll('button').forEach((button) => button.classList.add('disabled'));
    }
});

// Function used for scrolling the list based on the current index
const scrollDashboardListWidgets = function() {
    document.querySelectorAll('.dashboard-list-widget').forEach((widgetCardElement) => {
        const paginationElement = widgetCardElement.querySelector('.dashboard-list-widget-pagination');
        const list = widgetCardElement.querySelector('.dashboard-list-widget-list');

        const margin = 15;
        const cardWidth = list.querySelector('.card').offsetWidth + margin;
        const pageIndex = paginationElement.getAttribute('data-index');
        const maxIndex = paginationElement.getAttribute('data-max');
        let scrollAmount = pageIndex == 1 ? 0 : ((pageIndex - 1) * cardWidth);

        list.scroll({
            left: scrollAmount,
            top: 0,
            behavior: 'smooth'
        });

        if (list.clientWidth >= list.scrollWidth) {
            // The list doesn't need a scroll bar
            // Disable both buttons
            paginationElement.querySelectorAll('button').forEach((button) => button.classList.add('disabled'));
        } else if (list.clientWidth + scrollAmount >= list.scrollWidth) {
            // The list is scrolled to the end
            // Disable the next button
            paginationElement.querySelector('button.next').classList.add('disabled');
        } else if (pageIndex != maxIndex) {
            // Re-enable the next button
            paginationElement.querySelector('button.next').classList.remove('disabled');
        }
    });
}

// Handle resizing the window
const debouncedResizeHandler = debounce(function () {
    // Reset the scroll position to 0
    document.querySelectorAll('.dashboard-list-widget-pagination').forEach((paginationElement) => {
        paginationElement.setAttribute('data-index', '1');
    });
    scrollDashboardListWidgets();
}, 250);
window.addEventListener('resize', debouncedResizeHandler);

// Add click event listeners to list pagination buttons
document.querySelectorAll('.dashboard-list-widget-pagination > button').forEach((buttonElement) => {
    buttonElement.addEventListener('click', (event) => {
        const widgetCardElement = buttonElement.closest('.dashboard-list-widget');
        const paginationElement = widgetCardElement.querySelector('.dashboard-list-widget-pagination');
        const isPrevious = buttonElement.classList.contains('previous');
        const maxIndex   = parseInt(paginationElement.getAttribute('data-max'));
        let pageIndex    = parseInt(paginationElement.getAttribute('data-index'));

        pageIndex += (isPrevious ? -1 : 1);

        if (pageIndex >= 1 && pageIndex <= maxIndex) {
            paginationElement.setAttribute('data-index', pageIndex);

            const nextButton     = paginationElement.querySelector('button.next');
            const previousButton = paginationElement.querySelector('button.previous');
            nextButton.classList.toggle('disabled', pageIndex == maxIndex);
            previousButton.classList.remove('disabled');

            scrollDashboardListWidgets();
        }
    });
})

